module.exports = __webpack_public_path__ + "static/media/idandflo.9b6f3c6a.png";